<template>
  <div class="row">
    <div class="sm-12 md-4">
      <input type="text" placeholder="Nome" v-model="nome" />
    </div>
    <div class="sm-12 md-4">
      <input type="text" placeholder="RG/CPF ou Nº de documento" v-model="rg" />
    </div>
    <div class="sm-6 md-2">
      <button
        class="button secondary red full"
        @click.prevent.stop="remover"
        v-if="!removendo">
        Excluir
      </button>
      <button class="button secondary red full" v-else disabled>
        <i class="mdi mdi-spin mdi-loading"></i>
      </button>
    </div>
    <div class="sm-6 md-2">
      <button
        class="button secondary full"
        @click.prevent.stop="salvar"
        v-if="!salvando">
        Salvar
      </button>
      <button class="default-button full" v-else disabled>
        <i class="mdi mdi-spin mdi-loading"></i>
      </button>
    </div>
    <div class="sm-12"><hr /></div>
  </div>
</template>
<script>
import api from "/plugins/api";
import Swal from "sweetalert2";

export default {
  props: ["value"],
  data() {
    return {
      salvando: false,
      removendo: false,
      nome: "",
      rg: "",
    };
  },
  computed: {
    convidado() {
      return this.value;
    },
  },
  methods: {
    async salvar() {
      let nome = this.nome;
      let rg = this.rg;
      let id = this.value.id;
      let reserva_id = this.value.reserva_id;

      try {
        if ("" == nome) {
          return Swal.fire({
            icon: "error",
            title: "Oops",
            text: "Informe o nome",
          });
        }

        if ("" == rg) {
          return Swal.fire({
            icon: "error",
            title: "Oops",
            text: "Informe o RG/CPF ou Nº de documento",
          });
        }

        this.salvando = true;

        let { data: convidado } = await api.post(
          `reservas/${reserva_id}/convidados`,
          {
            id,
            reserva_id,
            nome,
            rg,
          }
        );

        Swal.fire({
          icon: "success",
          title: "Convidado salvo com sucesso!",
        });

        this.$emit("change", convidado);
      } catch (err) {
        if (err.response) {
          return Swal.fire({
            icon: "error",
            title: "Oops",
            text: err.response.data.error,
          });
        }
        Swal.fire({
          icon: "error",
          title: "Oops",
          text: "Não foi possível salvar o convidado.",
        });
        console.error(err);
      }
      this.salvando = false;
    },
    async remover() {
      try {
        let result = await Swal.fire({
          icon: "warning",
          title: "Deseja remover o convidado?",
          text: "Esta é uma operação irreversível, deseja continuar?",
          showCancelButton: true,
        });
        if (!result.isConfirmed) {
          return;
        }
        this.removendo = true;
        let id = this.value.id;
        let reserva_id = this.value.reserva_id;
        let { data } = await api.delete(
          `/reservas/${reserva_id}/convidados/${id}`
        );
        this.$emit("remove", id);
      } catch (err) {
        if (err.response) {
          return Swal.fire({
            icon: "error",
            title: "Oops",
            text: err.response.data.error,
          });
        }
        Swal.fire({
          icon: "error",
          title: "Oops",
          text: "Não foi possível salvar o convidado.",
        });
        console.error(err);
      }
      this.removendo = false;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.nome = value.nome;
        this.rg = value.rg;
      },
    },
  },
};
</script>
